import {Injectable} from '@angular/core';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {SellerContractContactType} from './seller-contract-contact-type.enum';
import {ItemSummaryContactInfoService} from './item-summary-contact-info.service';
import {Contact} from '@rbaip/address-form';
import {appConfig} from '../app.config';

@Injectable()
export class ItemSummaryAssetContactInfoServiceImpl implements ItemSummaryContactInfoService {

  constructor(private http: HttpClient) {
  }

  public saveContact(eventId: number, equipId: number, contact: Contact, contactType: SellerContractContactType): Observable<any> {
    const url = `/api/auction-events/${eventId}/equipment/${equipId}/asset/contacts?contactType=${contactType}`;

    const body = contact ? JSON.stringify(contact) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('saveAssetContact', null))
      );
  }

  public deleteContact(eventId: number, equipId: number, contactId: number, contactType: SellerContractContactType): Observable<any> {
    const url = `/api/auction-events/${eventId}/equipment/${equipId}/asset/contacts/${contactId}?contactType=${contactType}`;

    return this.http.delete(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('deleteAssetContact', null))
      );
  }
}
